export const fEur = (n: number) => {
  return n.toLocaleString('sk-SK', { style: 'currency', currency: 'EUR' });
};

export const fPercent = (n: number) => {
  return (n / 100).toLocaleString('sk-SK', { style: 'percent' });
};
